import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { CurrentUserService } from '®shared/current-user';
import { UserInstitutionalRole } from '®shared/user';

@Component({
  selector: 'rl-lti-missing-content',
  templateUrl: './lti-missing-content.component.html',
  styleUrls: ['./lti-missing-content.component.scss'],
})
export class LtiMissingContentComponent implements OnInit, OnDestroy {
  private currentUserSubscription: Subscription;

  instructor = UserInstitutionalRole.ACADEMIC;
  student = UserInstitutionalRole.STUDENT;

  userType = null;

  constructor(private currentUserService: CurrentUserService) {}

  ngOnInit(): void {
    this.currentUserSubscription = this.currentUserService
      .getCurrentUser()
      .subscribe(currentUserAndPermissions => {
        this.userType = currentUserAndPermissions.canAccessDraftLists
          ? this.instructor
          : this.student;
      });
  }

  ngOnDestroy(): void {
    if (this.currentUserSubscription) {
      this.currentUserSubscription.unsubscribe();
    }
  }
}
